module.exports = __webpack_public_path__ + "static/media/Tijera.612d0680.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Tijera.png
// module id = 182
// module chunks = 0